function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   min-height: ", ";\n   padding-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { math } from 'polished';
import PropTypes from 'prop-types';
var SiteBody = styled.main(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      fixedHeader = _ref.fixedHeader;
  return "calc(100vh - ".concat(fixedHeader ? theme.sizes.siteFooterHeight : math("".concat(theme.sizes.siteHeaderHeight, " + ").concat(theme.sizes.siteFooterHeight)), ");");
}, function (_ref2) {
  var theme = _ref2.theme,
      fixedHeader = _ref2.fixedHeader;
  return fixedHeader ? theme.sizes.siteHeaderHeight : '0';
});
SiteBody.propTypes = {
  fixedHeader: PropTypes.bool
};
SiteBody.defaultProps = {
  fixedHeader: false
};
export { SiteBody };